import ApiService from "@/core/services/api.service";

// action types
export const FETCH_LIVE_RECEIPTS = "fetchLiveReceipts";
export const FETCH_LIVE_RECEIPT = "fetchLiveReceipt";
// export const FETCH_COMPANY_LIVE_RECEIPTS = "fetchCompanyLiveReceipts";
export const FETCH_ADMIN_LIVE_RECEIPTS = "fetchAdminLiveReceipts";

// mutation types
export const SET_LIVE_RECEIPTS = "setLiveReceipts";
export const SET_LIVE_RECEIPTS_PAGINATION = "setLiveReceiptsPagination";
export const SET_LIVE_RECEIPT = "setLiveReceipt";

const state = {
  liveReceipts: [],
  liveReceiptsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  liveReceipt: {}
};

const getters = {
  liveReceipts(state) {
    return state.liveReceipts;
  },

  liveReceiptsPagination(state) {
    return state.liveReceiptsPagination;
  },

  liveReceipt(state) {
    return state.liveReceipt;
  }
};

const actions = {
  [FETCH_LIVE_RECEIPTS](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("receipts/lives", {
        params: {
          page: context.state.liveReceiptsPagination.currentPage
        }
      })
        .then(({ data }) => {
          context.commit(SET_LIVE_RECEIPTS, data.data);
          context.commit(SET_LIVE_RECEIPTS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_LIVE_RECEIPT](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get("receipts/lives", id)
        .then(({ data }) => {
          context.commit(SET_LIVE_RECEIPT, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_ADMIN_LIVE_RECEIPTS](context) {
    return new Promise((resolve, reject) => {
      ApiService.query("admin/receipts/lives", {
        params: {
          page: context.state.liveReceiptsPagination.currentPage
        }
      })
        .then(({ data }) => {
          context.commit(SET_LIVE_RECEIPTS, data.data);
          context.commit(SET_LIVE_RECEIPTS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_LIVE_RECEIPTS](state, data) {
    state.liveReceipts = data;
  },
  [SET_LIVE_RECEIPTS_PAGINATION](state, data) {
    state.liveReceiptsPagination = data;
  },
  [SET_LIVE_RECEIPT](state, liveReceipt) {
    state.liveReceipt = liveReceipt;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
